import React, { useContext } from "react";
import { useLocation, NavLink as NavLinkRRD, Link } from "react-router-dom";
import classnames from "classnames";
import { PropTypes } from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav
} from "reactstrap";
  //import { get_permission } from "network/ApiAxios";
import jQuery from 'jquery';
import { UserContext } from "layouts/store";
function Sidebar({ toggleSidenav, sidenavOpen, routes, logo, rtlActive }) {
  const get_permission_extend = useContext(UserContext);
  const [state, setState] = React.useState({});
  const [infoState, setinfoState] = React.useState(false);  
  const [params, setParams] = React.useState(null);
  const location = useLocation();
  var forparse = localStorage.getItem("user");
  const {userType} = JSON.parse(forparse);
  
  React.useEffect(async () => {
    jQuery(".navbar-nav").hide()
    var userdata = localStorage.getItem('user');
    var jsondata = JSON.parse(userdata);
    var gerParam = new URLSearchParams(location.search).get("company");
   var idcompany = null;
    if (jsondata.userType==2) {
      if (gerParam!=null) {
        setParams(location.search)
        idcompany = gerParam
      }
    }

    
    setState(getCollapseStates(routes));
    // eslint-disable-next-line
  }, []);
   const setInfoInit = () =>{
        var userdata = localStorage.getItem('user');
        var jsondata = JSON.parse(userdata);
        if (infoState) {
        return;  
        }
        if (get_permission_extend.valueGlobal.length!=0) {
              setinfoState(true)
            }else{
              return
            }
   var getTypeAreaWork = localStorage.getItem('type_area_work')
   if (getTypeAreaWork=='trazability') {
    jQuery("#gestióndecultivos").remove()
    jQuery("#comercialización").remove()
   }
   if (getTypeAreaWork=='production') {
    jQuery("#trazabilidad").remove()
    jQuery("#comercialización").remove()
   }
   if (getTypeAreaWork=='commerce') {
    jQuery("#trazabilidad").remove()
    jQuery("#gestióndecultivos").remove()
   }

    var dataPermission = get_permission_extend.valueGlobal
    var dataPermissionMain = get_permission_extend.valueDataMain
        var regexStr = /V1F|V2F|V3F|V4F/gi
      if (dataPermission.type_traza.indexOf('T')==-1) {
        if (dataPermission.type_traza.search(regexStr)==-1) {
          jQuery("#trazabilidad").remove()
        }
        if (dataPermission.type_traza.search(regexStr)!=-1) {
          jQuery("#frutasyvegetales").remove()
          jQuery("#frutasyvegetaleskdes").remove()
          jQuery("#cárnicos").remove()
          jQuery("#granos").remove()
          jQuery("#procesados").remove()
          jQuery("#pescadosymariscos").remove()
          jQuery("#vistatrace").remove()
          jQuery("#trazabilidadenproceso").remove()
          jQuery("#historial").remove()
          jQuery("#blockchain").remove()
        }
      }
      if (dataPermission.type_traza.indexOf('P')==-1) {
        jQuery("#gestióndecultivos").remove()
      }
      if (dataPermission.type_traza.indexOf('C')==-1) {
        jQuery("#comercialización").remove()
      }
      if (dataPermission.role==1 || dataPermission.role==2) {
          jQuery("#productores").remove()
          jQuery("#producciónmonitorear").remove()
      }
    if (dataPermission.role==2) {
          jQuery(".navbar-nav").show()
          //console.log(dataPermission.type_traza)
            if (dataPermission.type_traza.indexOf('P')==-1) {
              jQuery("#registrarnuevaproducción").remove()
              jQuery("#producciónenproceso").remove()
              jQuery("#vistaproducción").remove()
              //jQuery("#blockchain").remove()
              //jQuery("#historial").remove()
            }
      
            jQuery("#administración").remove()
            jQuery("#agregarcolaborador").remove()
            if (dataPermission.type_traza=='VF') {
              jQuery("#cárnicos").remove()
              jQuery("#procesados").remove()
              jQuery("#pescadosymariscos").remove()
            }
           if (dataPermission.type=='view') {
            jQuery("#satélitesenproceso").remove()
            jQuery("#registrarnuevaproducción").remove()
            jQuery("#producciónenproceso").remove()
            jQuery("#blockchain").remove()
            //jQuery("#historial").remove()
           }
            if (dataPermission.type_traza.indexOf('VF')!=-1) {
              
              jQuery("#iniciartrazabilidad").remove()
              jQuery("#operaciones").remove()
              jQuery("#trazabilidadenprocesokdes").remove()
              //jQuery("#trazabilidadenproceso").remove()
            }
            if (dataPermission.type=='admin') {
              jQuery("#satélitesenproceso").remove()
              jQuery("#registrarnuevaproducción").remove()
              jQuery("#blockchain").remove()
              jQuery("#historial").remove()
            }
            // if (dataPermission.type_traza.search(regexStr)!=-1) {
            //   return
            // }
            if (dataPermission.type=='options' && dataPermission.type_traza.search(regexStr)==-1) {
              jQuery("#satélitesenproceso").remove()
              jQuery("#registrarnuevaproducción").remove()
              jQuery("#blockchain").remove()
              jQuery("#historial").remove()
              jQuery("#vegetalesyfrutas").remove()
              jQuery("#cárnicos").remove()
              jQuery("#granos").remove()
              jQuery("#procesados").remove()
              jQuery("#pescadosymariscos").remove()
            }
            jQuery("#usuarios").remove()
        }else{

          if (dataPermission.type_traza.indexOf('VF')!=-1) {
            jQuery("#trazabilidadenprocesokdes").remove()
          }
          jQuery(".navbar-nav").show()
        }

        if (dataPermission.role==4) {
          if (dataPermission.type_traza!="ON") {
            jQuery("#monitorear").remove()
          }
          jQuery("#operaciones").remove()
          jQuery("#usuarios").remove()
          jQuery("#capacitación").remove()
          jQuery("#mibilletera").remove()
          jQuery("#serviciocontratado").remove()
          jQuery("#comprarservicios").remove()
          
        }

      }
      setInfoInit()
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // makes the sidenav normal on hover (actually when mouse enters on it)
  const onMouseEnterSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  };
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  const onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  };
  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes
  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  const closeSidenav = () => {
    if (window.innerWidth < 1200) {
      toggleSidenav();
    }
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect || prop.api) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <NavItem id={String(prop.name).replaceAll(' ','').toLowerCase()} key={key}>
            <NavLink
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              className={classnames({
                active: getCollapseInitialState(prop.views),
              })}
              onClick={(e) => {
                e.preventDefault();
                setState(st);
              }}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        (prop.miniName !== undefined) ? (
                <NavItem className={activeRoute(prop.layout + prop.path)} id={String(prop.name).replaceAll(' ','').toLowerCase()} key={key}>
                  <NavLink
                    to={{
                      pathname:(params==null)?(prop.layout + prop.path):(prop.layout + prop.path + params),
                      state: { title_name: prop.name }
                    }}
                    activeClassName=""
                    onClick={closeSidenav}
                    tag={Link}
                  >
                    {prop.icon !== undefined ? (
                      <>
                        <i className={prop.icon} />
                        <span className="nav-link-text">{prop.name}</span>
                      </>
                    ) : prop.miniName !== undefined ? (
                      <>
                        <span className="sidenav-mini-icon"> {prop.miniName} </span>
                        <span className="sidenav-normal"> {prop.name} </span>
                      </>
                    ) : (
                      prop.name
                    )}
                  </NavLink>
                </NavItem>):(null)
      );
    });
  };

  const createApiLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect || !prop.api || !prop.access.includes(userType)) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              href="#"
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              className={classnames({
                active: getCollapseInitialState(prop.views),
              })}
              onClick={(e) => {
                e.preventDefault();
                setState(st);
              }}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            activeClassName=""
            onClick={closeSidenav}
            tag={NavLinkRRD}
          >
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <span className="nav-link-text">{prop.name}</span>
              </>
            ) : prop.miniName !== undefined ? (
              <>
                <span className="sidenav-mini-icon"> {prop.miniName} </span>
                <span className="sidenav-normal"> {prop.name} </span>
              </>
            ) : (
              prop.name
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }
  const scrollBarInner = (
    <div className="scrollbar-inner">
      <div className="sidenav-header d-flex align-items-center">
        {logo ? (
          <NavbarBrand {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
            <div style={{fontWeight: '700',fontSize: '12px',textAlign: 'center'}}>Versión 2.1.4</div>
          </NavbarBrand>
        ) : null}
              <div className="d-xl-none">
                <div
                  className={classnames(
                    "pr-3 sidenav-toggler",
                    { active: toggleSidenav }
                  )}
                  onClick={toggleSidenav}
                >
                  <div className="fas fa-times-circle" style={{color:'#002a5c'}}>
                  </div>
                </div>
              </div>
{/*        <div className="ml-auto">
          <div
            className={classnames("sidenav-toggler d-none d-xl-block", {
              active: sidenavOpen,
            })}
            onClick={toggleSidenav}
          >
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
            </div>
          </div>
        </div>*/}
      </div>
      <div className="navbar-inner">
        <Collapse navbar isOpen={true}>
          <Nav navbar>{createLinks(routes)}</Nav>
          <Nav navbar>{createApiLinks(routes)}</Nav>
          <hr className="my-3" />
        </Collapse>
      </div>
    </div>
  );
  return (
    <Navbar
      className={
        "sidenav navbar-vertical navbar-expand-xs navbar-light bg-white " +
        (rtlActive ? "" : "fixed-left")
      }
      onMouseEnter={onMouseEnterSidenav}
      onMouseLeave={onMouseLeaveSidenav}
    >
      {navigator.platform.indexOf("Win") > -1 ? (
        <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
      ) : (
        scrollBarInner
      )}
    </Navbar>
  );
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => {},
  sidenavOpen: false,
  rtlActive: false,
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
  // rtl active, this will make the sidebar to stay on the right side
  rtlActive: PropTypes.bool,
};

export default Sidebar;
